import { render, staticRenderFns } from "./CoefficientiDealer.vue?vue&type=template&id=544de60b&"
import script from "./CoefficientiDealer.vue?vue&type=script&lang=js&"
export * from "./CoefficientiDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports